import { Grid } from '@mui/material';
import React from 'react';
import { jbColors } from 'theme/jbColors';

const RightSideBottomBar = ({ children }: { children?: React.ReactNode }) => {
  return (
    <Grid
      data-testid={'right-side-bottom-bar'}
      container
      sx={{
        height: '88px',
        position: 'fixed',
        bottom: 0,
        ml: '0em',
        width: '50%',
        backgroundColor: jbColors.core.stone[20],
        alignItems: 'center',
        justifyContent: 'flex-end',
        display: 'flex',
        padding: '8px',
      }}
    >
      {children}
    </Grid>
  );
};

export default RightSideBottomBar;
